import React, { useEffect, useRef, useState } from "react";
import { Disclosure, DisclosureButton } from "@headlessui/react";
import Pagination from "../../shared/common/pagination";
import { ISubjectPage } from "../../../model/interface/subject";
import MultiSelectList from "../questions/metadataDropDownList";
import { IGrade, IState } from "../../../model/interface/domain";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import { DropdownItem } from "../../../model/interface/keyValuePair";
import {
  CaretDownSolidIcon,
  CaretUpSolidIcon,
  CollapseDownIcon,
  CollapseUpIcon,
  DeleteIcon,
  EditIcon,
  FilterIcon,
  ResetIcon,
} from "../../../assets/icons/index";
import {
  getGradeAll,
  getStateAll,
  getSubject,
} from "../../../api/subject.service";
import {
  IStandardGroupDTO,
  IStandardGroupSearchRequest,
  IStandardGroupStandardDTO,
  IStandardGroupStandardSearchRequest,
} from "../../../model/interface/standardGroup";
import {
  getStandardGroups,
  getStandardGroupStandards,
  deleteStandardGroup,
  deleteStandardGroupStandard,
} from "../../../api/standardGroup.service";
import DeleteModal from "../../shared/common/deleteModal";
import Loader from "../../shared/loader/loader";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router";
import Constant from "../../../utils/constant";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
interface StandardGroupProps {
  profile: any;
}

const StandardGroup = (props: StandardGroupProps) => {
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const column = {
    StandardGroupId: "StandardGroupId",
    Name: "Name",
  };

  const [toggle, setToggle] = useState<number>();
  const [grades, setGrades] = useState<IGrade[]>([]);
  const [states, setStates] = useState<IState[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [subjects, setSubjects] = useState<ISubjectPage[]>([]);
  const [domains, setDomains] = useState<DropdownItem[]>([]);
  const [isActive, setisActive] = useState<boolean>(true);
  const [groupId, setGroupId] = useState<number>(0);
  const [groupName, setGroupName] = useState("");
  const [standardName, setStandardName] = useState("");
  const [selectState, setSelectState] = useState<number>(0);
  const [selectGrade, setSelectGrade] = useState<number>(0);
  const [selectSubject, setSelectSubject] = useState<number>(0);
  const [selectDomain, setSelectedDomain] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [deleteStandardGroupId, setDeleteStandardGroupId] = useState<number>(0);
  const [deleteStandardId, setDeleteStandardId] = useState<number>(0);
  const [sortByDesc, setSortByDesc] = useState<boolean>(true);
  const [orderByColumn, setOrderByColumn] = useState(column.StandardGroupId);
  const [groupedStandards, setGroupedStandards] = useState<
    Array<IStandardGroupStandardDTO>
  >([]);
  const [standardGroups, setStandardGroups] = useState<
    Array<IStandardGroupDTO>
  >([]);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const navigate = useNavigate();

  useEffect(() => {
    getStateData();
    getGradeData();
  }, []);

  useEffect(() => {
    if (selectState > 0 && selectGrade > 0) {
      getSubjectData();
    }
    if (selectSubject > 0) {
      getDomainsData();
    }
  }, [selectState, selectGrade, selectSubject]);

  useEffect(() => {
    if (isLoaded && !isFilter) {
      filterHandler();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1 && !isFilter) {
      filterHandler();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  useEffect(() => {
    if (isLoaded) {
      filterHandler();
    }
  }, [sortByDesc]);

  const getStateData = async () => {
    const response = getStateAll(999, 1);
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.stateId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setStates(newStateData);
  };

  const getGradeData = async () => {
    const response = getGradeAll(999, 1);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );

      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setGrades(newGradeData);
  };

  const getSubjectData = async () => {
    setLoading(true);
    const params = {
      name: "",
      contentAreaId: 0,
      stateId: selectState || 0,
      gradeId: selectGrade || 0,
      gradeLevel: "",
      orderbyColumn: "name",
      sortDir: "asc",
      pageSize: 999,
      pageNumber: 1,
      isActive: true,
      isApproved: true,
    };

    const response = getSubject(params);
    const data = (await response).data;
    setLoading(false);
    let newSubjectData = [];
    if (data.data.length > 0) {
      const loSubjects = data.data.filter((r) => r.subjectTypeName === "LO");
      newSubjectData = loSubjects.map((eachSubjectData) => {
        return {
          value: eachSubjectData.subjectId || 0,
          label: `${eachSubjectData.name}`,
        };
      });
    }
    setSubjects(newSubjectData);
  };

  const getDomainsData = async () => {
    setLoading(true);
    const service = await import("../../../api/domain.service");
    service.getAllDomainsBySubject(selectSubject, 9999, 1).then((res) => {
      const domainDDLData = res.data.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.domainId,
        };
      });
      setDomains(domainDDLData);
      setLoading(false);
    });
  };

  const filterHandler = (isFilter?, isReset?) => {
    setLoading(true);
    if (isFilter) setIsFilter(true);

    const standard: IStandardGroupSearchRequest = {
      standardGroupId: isReset ? 0 : groupId,
      name: isReset ? "" : groupName,
      standardName: isReset ? "" : standardName,
      stateId: isReset ? 0 : selectState,
      gradeId: isReset ? 0 : selectGrade,
      subjectId: isReset ? 0 : selectSubject,
      domainId: isReset ? 0 : selectDomain,
      isActive: isReset ? true : isActive,
    };

    getStandardGroups(
      standard,
      isFilter ? defaultPageNumber : pageNumber,
      isFilter ? defaultPageSize : pageSize,
      sortByDesc ? "ASC" : "DESC",
      orderByColumn
    )
      .then((r) => {
        setStandardGroups(r.data.data);
        setTotalPages(
          Math.ceil(
            r.data.totalRecords / (isReset ? defaultPageSize : pageSize)
          )
        );
        setTotalRecords(r.data.totalRecords);
        setLoading(false);
        if (isFilter) {
          paginationRef?.current?.onReset();
          pageSizeRef?.current?.onReset();

          setIsFilter(false);
        }
      })
      .catch((r) => {
        setLoading(false);
      });
  };

  const getStandardGroupStandardData = async (standardGroupId) => {
    const groupStandardSearchReq: IStandardGroupStandardSearchRequest = {
      standardGroupId: standardGroupId,
      standardId: 0,
      isActive: true,
    };
    const response = getStandardGroupStandards(
      groupStandardSearchReq,
      1,
      99999
    );
    const data = (await response).data;
    setGroupedStandards(data.data);
    return await response;
  };

  const handleSortBy = (column: string) => {
    setSortByDesc(!sortByDesc);
    setOrderByColumn(column);
  };

  const handleShowStandards = async (standardGroupId, index?, type?) => {
    setLoading(true);
    if (type === "show") {
      getStandardGroupStandardData(standardGroupId).then(() => {
        setToggle(index);
      });
    } else {
      setToggle(undefined);
    }
    setLoading(false);
  };

  const confirmDelete = (groupId: number, standardId: number) => {
    setDeleteStandardGroupId(groupId);
    setDeleteStandardId(standardId);
    setShowDeleteModal(true);
  };

  const handleDeleteStandardGroup = (groupId: number) => {
    setLoading(true);
    deleteStandardGroup(groupId, props.profile?.userId)
      .then(() => {
        filterHandler();
        setLoading(false);
      })
      .catch((r) => {
        setLoading(false);
      });
    setShowDeleteModal(false);
  };

  const handleDeleteStandard = (groupId: number, standardId: number) => {
    deleteStandardGroupStandard(groupId, standardId, props.profile?.userId)
      .then(() => {
        getStandardGroupStandardData(groupId);
        setLoading(false);
      })
      .catch((r) => {
        setLoading(false);
      });
    setShowDeleteModal(false);
  };

  const handleOnDeleteConfirm = () => {
    if (deleteStandardId > 0 && deleteStandardGroupId > 0) {
      handleDeleteStandard(deleteStandardGroupId, deleteStandardId);
    } else if (deleteStandardGroupId > 0) {
      handleDeleteStandardGroup(deleteStandardGroupId);
    }
  };

  const resetClickHandler = () => {
    setGroupId(0);
    setGroupName("");
    setStandardName("");
    setSelectSubject(0);
    setSelectedDomain(0);
    setSelectState(0);
    setSelectGrade(0);
    setResetDropdownFlag(!resetDropdownFlag);
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
    filterHandler(false, true);
  };

  /** Code to implement input type number to support all browsers */
  useEffect(() => {
    const input = document.getElementById("groupId");
    if (input) {
      input.addEventListener("keypress", (e: any) => {
        const keyValue = e.key;
        if (!e.target.value && e.key == 0) {
          e.preventDefault();
        } else {
          if (!/[0-9.]/.test(keyValue)) {
            e.preventDefault();
          }
        }
      });
    }
  }, []);

  const handleRedirect = (id?: number | string) => {
    navigate(
      id
        ? Constant.STANDARDGROUPEDIT.replace(":id", id.toString())
        : Constant.STANDARDGROUPS,
      { state: { idToEdit: id } }
    );
  };

  return (
    <AllowedTo
      perform={Permissions.standard_group_view}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                Standard Group
              </h3>
            </div>

            <div className="pt-6 border-b pb-6">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-2 sm:col-span-2 ">
                  <label className="text-sm text-gray-700">Group Id</label>
                  <div className="contentArea">
                    <input
                      id="groupId"
                      name="groupId"
                      type="number"
                      autoComplete="off"
                      value={groupId || ""}
                      className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      onChange={(e) => {
                        setGroupId(Number(e.target.value));
                      }}
                    />
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-2 ">
                  <label className="text-sm text-gray-700">Group Name</label>
                  <div className="contentArea">
                    <input
                      id="groupName"
                      name="groupName"
                      type="text"
                      autoComplete="off"
                      value={groupName}
                      className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      onChange={(e) => {
                        setGroupName(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-2 ">
                  <label className="text-sm text-gray-700">Standard Name</label>
                  <div className="contentArea">
                    <input
                      id="name"
                      name="name"
                      type="text"
                      value={standardName}
                      autoComplete="off"
                      className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      onChange={(e) => {
                        setStandardName(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="col-span-2">
                  <label className="text-sm text-gray-700">State</label>
                  <div className="mt-1 text-sm">
                    <MultiSelectList
                      dropValue={states}
                      defaultValue={"State"}
                      value={selectState}
                      resetDropdown={resetDropdownFlag}
                      dropSelect={setSelectState}
                      multiple={false}
                    />
                  </div>
                </div>
                <div className="col-span-2">
                  <label className="text-sm text-gray-700">Grade</label>
                  <div className="mt-1 text-sm">
                    <MultiSelectList
                      dropValue={grades}
                      defaultValue={"Grade"}
                      value={selectGrade}
                      resetDropdown={resetDropdownFlag}
                      dropSelect={setSelectGrade}
                      multiple={false}
                    />
                  </div>
                </div>

                <div className="col-span-2">
                  <label className="text-sm text-gray-700">Subject</label>
                  <div className="mt-1 text-sm">
                    <MultiSelectList
                      dropValue={subjects}
                      defaultValue={"Subject"}
                      value={selectSubject}
                      resetDropdown={resetDropdownFlag}
                      dropSelect={setSelectSubject}
                      multiple={false}
                    />
                  </div>
                </div>

                <div className="col-span-2">
                  <label className="text-sm text-gray-700">Domain</label>
                  <div className="mt-1 text-sm">
                    <MultiSelectList
                      dropValue={domains}
                      defaultValue={"Domain"}
                      value={selectDomain}
                      resetDropdown={resetDropdownFlag}
                      dropSelect={setSelectedDomain}
                      multiple={false}
                    />
                  </div>
                </div>

                <div className="col-span-1 sm:col-span-1 flex items-end hidden">
                  <div className="flex flex-row items-center ">
                    <input
                      id="isActive"
                      name="isActive"
                      type="checkbox"
                      checked={isActive}
                      onChange={() => {
                        setisActive(!isActive);
                      }}
                      className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                    />
                    <label className="ml-1.5 text-sm text-gray-700">
                      Active
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-start">
                <button
                  className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  onClick={() => {
                    filterHandler(true, false);
                  }}
                >
                  <FilterIcon className="w-3 h-3"></FilterIcon>
                  <span>Filter</span>
                </button>
                <button
                  type="button"
                  onClick={resetClickHandler}
                  className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <ResetIcon className="w-3 h-3"></ResetIcon>
                  <span>Reset Filter</span>
                </button>
              </div>
            </div>

            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table className="relative  min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color sticky top-0">
                          <tr>
                            <th
                              scope="col"
                              className="sticky top-0 px-5 py-2 w-28 font-light text-sm text-left text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Id
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === column.StandardGroupId ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy(column.StandardGroupId)
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy(column.StandardGroupId)
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="sticky top-0  px-3 py-2 font-light text-sm text-left text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Name
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === column.Name ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy(column.Name)}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy(column.Name)}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Associated Subjects
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Associated Galaxies
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="w-20 px-3 py-2 font-light text-sm text-left text-white tracking-wider"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="z-10">
                          {standardGroups &&
                            standardGroups.map((group, index) => (
                              <Disclosure key={index}>
                                <>
                                  <tr
                                    key={group.standardGroupId}
                                    className={
                                      index % 2 === 0
                                        ? "bg-white"
                                        : "bg-gray-100"
                                    }
                                  >
                                    <td className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500 relative">
                                      {group.isActive ? (
                                        <span className="mr-1 h-4/5 w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                      ) : (
                                        <span className="mr-1 h-4/5 w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                      )}
                                      <div className="flex">
                                        <div>
                                          <DisclosureButton className="">
                                            {index !== toggle && (
                                              <CollapseDownIcon
                                                key={index}
                                                className={`w-5 h-5`}
                                                onClick={(e) => {
                                                  handleShowStandards(
                                                    group?.standardGroupId,
                                                    index,
                                                    "show"
                                                  );
                                                }}
                                              />
                                            )}

                                            {index === toggle && (
                                              <CollapseUpIcon
                                                key={index}
                                                className={`w-5 h-5`}
                                                onClick={(e) => {
                                                  handleShowStandards(
                                                    group?.standardGroupId,
                                                    index,
                                                    "hide"
                                                  );
                                                }}
                                              />
                                            )}
                                          </DisclosureButton>
                                        </div>

                                        <Link
                                          className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                          to={Constant.STANDARDGROUPEDIT.replace(
                                            ":id",
                                            group.standardGroupId.toString()
                                          )}
                                        >
                                          {group.standardGroupId}
                                        </Link>
                                      </div>
                                    </td>
                                    <td className="px-3 py-2">
                                      <Link
                                        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                        to={Constant.STANDARDGROUPEDIT.replace(
                                          ":id",
                                          group.standardGroupId.toString()
                                        )}
                                      >
                                        {group.name}
                                      </Link>
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm font-normal text-gray-500">
                                      {group?.associatedSubjects?.map(
                                        (data, i) => (
                                          <div key={i} className="grid">
                                            <Link
                                              to={`/subjects/edit/${data.id}`}
                                              state={{ subjectType: 1 }}
                                              className="font-medium text-indigo-600 cursor-pointer hover:text-indigo-500 hover:underline"
                                            >
                                              {data.name}
                                            </Link>
                                          </div>
                                        )
                                      )}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm font-normal text-gray-500">
                                      {group?.associatedGalaxies?.map(
                                        (data, i) => (
                                          <div key={i} className="grid">
                                            {data.name}
                                          </div>
                                        )
                                      )}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-700">
                                      <div className="flex justify-center">
                                        <AllowedTo
                                          perform={
                                            Permissions.standard_group_modify
                                          }
                                        >
                                          <EditIcon
                                            onClick={() =>
                                              handleRedirect(
                                                group?.standardGroupId
                                              )
                                            }
                                            className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                          />
                                        </AllowedTo>

                                        <AllowedTo
                                          perform={
                                            Permissions.standard_group_delete
                                          }
                                        >
                                          <DeleteIcon
                                            onClick={() => {
                                              confirmDelete(
                                                group.standardGroupId,
                                                0
                                              );
                                            }}
                                            className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                          />
                                        </AllowedTo>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={4} className="relative ">
                                      <div
                                        className={`${
                                          index !== toggle ? "hidden" : ""
                                        }  pl-12 pr-12 px-4 pt-4 pb-2 text-sm text-gray-500`}
                                      >
                                        {group.isActive ? (
                                          <span className="w-0.5 h-4/5  bg-green-500  inline-block absolute top-0 left-1.5"></span>
                                        ) : (
                                          <span className="w-0.5 h-4/5  bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                        )}
                                        <div className="shadow border rounded-md">
                                          <table className="min-w-full">
                                            <thead>
                                              <tr className="bg-gray-50 border">
                                                <th
                                                  scope="col"
                                                  className="inline-flex items-center gap-2 px-3 py-2 pl-6 font-semibold text-xs text-left tracking-wider"
                                                >
                                                  <span className="flex gap-2">
                                                    Standard Id
                                                  </span>
                                                </th>
                                                <th
                                                  scope="col"
                                                  className="px-3 py-2 pl-6 font-semibold text-xs text-left  tracking-wider"
                                                >
                                                  <span className="flex gap-2">
                                                    Code
                                                  </span>
                                                </th>
                                                <th
                                                  scope="col"
                                                  className="px-3 py-2 pl-6 font-semibold text-xs text-left  tracking-wider"
                                                >
                                                  <span className="flex gap-2">
                                                    Name
                                                  </span>
                                                </th>
                                                <th
                                                  scope="col"
                                                  className="px-3 w-20 py-2 pl-6 font-semibold text-xs text-left text-gray-500 tracking-wider"
                                                >
                                                  <span className="flex gap-2">
                                                    Action
                                                  </span>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-50">
                                              {groupedStandards.map(
                                                (standard, index) => (
                                                  <tr key={index}>
                                                    <td className="font-medium pl-6">
                                                      <Link
                                                        to={Constant.EDITSTANDARD.replace(
                                                          ":id",
                                                          standard.standardId
                                                            ? standard.standardId.toString()
                                                            : ""
                                                        )}
                                                        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                                      >
                                                        {standard.standardId}
                                                      </Link>
                                                    </td>
                                                    <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                      <Link
                                                        className={`ml-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline`}
                                                        to={Constant.EDITSTANDARD.replace(
                                                          ":id",
                                                          standard?.standardId?.toString()
                                                        )}
                                                      >
                                                        {standard.standardCode}
                                                      </Link>
                                                    </td>
                                                    <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                      <a
                                                        className={`ml-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline`}
                                                        href={Constant.EDITSTANDARD.replace(
                                                          ":id",
                                                          standard?.standardId?.toString()
                                                        )}
                                                      >
                                                        {standard.standardName}
                                                      </a>
                                                    </td>
                                                    <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-700">
                                                      <div className="">
                                                        <DeleteIcon
                                                          onClick={() => {
                                                            confirmDelete(
                                                              standard.standardGroupId,
                                                              standard.standardId
                                                            );
                                                          }}
                                                          className="w-4 text-xs cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                                        />
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              </Disclosure>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  {standardGroups.length !== 0 ? (
                    <>
                      <Pagination
                        pages={totalPages}
                        setPageNumber={(e) => {
                          setPageNumber(e);
                          setToggle(undefined);
                        }}
                        ref={paginationRef}
                      />
                      <span>
                        <span className="text-sm pr-4 ml-auto text-left-700">
                          Showing {pageNumber} to{" "}
                          {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                          {totalRecords} results
                        </span>

                        <SelectPageSize
                          setPageSize={setPageSize}
                          type={"second"}
                          ref={pageSizeRef}
                        />
                      </span>
                    </>
                  ) : (
                    <p className="p-2">No Records Found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={() => {
            setShowDeleteModal(false);
          }}
          deleteRecord={handleOnDeleteConfirm}
        />
      )}
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(StandardGroup);
